import { BadgeCheck } from "lucide-react";

export const getTier = (b) =>
  b?.verification_tier || (b?.gst_verified ? "gst" : b?.msme_verified ? "msme" : "basic");

// Tiered trust badge. gst = blue check + "GST Verified"; msme = grey check + "MSME Verified"; basic = nothing.
export const VerifiedBadge = ({ tier, size = "sm", iconOnly = false }) => {
  if (tier !== "gst" && tier !== "msme") return null;
  const isGst = tier === "gst";
  const label = isGst ? "GST Verified" : "MSME Verified";
  const iconColor = isGst ? "text-brand" : "text-slate-400";
  const iconSize = size === "lg" ? 15 : size === "md" ? 14 : 12;

  if (iconOnly) {
    return <BadgeCheck size={iconSize} className={iconColor} aria-label={label} data-testid={`verified-badge-${tier}`} />;
  }

  const chip = isGst
    ? "bg-blue-50 border-blue-200 text-brand"
    : "bg-slate-100 border-slate-200 text-slate-600";
  const pad = size === "lg" ? "px-2.5 py-1 text-xs" : "px-2 py-0.5 text-[10px]";

  return (
    <span data-testid={`verified-badge-${tier}`} className={`inline-flex items-center gap-1 rounded-full border font-bold ${chip} ${pad}`}>
      <BadgeCheck size={iconSize} className={iconColor} /> {label}
    </span>
  );
};
